import React, {Component} from 'react';
import {inject, observer } from 'mobx-react';
import ReservationHeader from '../components/ReservationHeader';
import _ from "lodash";
import ReservationTicketItems from "../components/ReservationTicketItems";

@inject(
    'ticketStore',
    'packageStore',
    'reservationStore'
)
@observer
export default class ReservationPage extends Component {

    constructor(props) {
        super(props);

        this.state = {
            isLoaded: false
        };

        this.renderGroups = this.renderGroups.bind(this);
    }

    componentWillMount() {
        this.setTicketListInStore();
    }

    setTicketListInStore = () => {
        const {
            ticketStore: {
                getShopSequence,
                getTicketInfo,
                setTicketGroups: setTicketGroupsInStore,
            },
            location,
        } = this.props;
        if(!location) return false;
        const pathname = location.pathname;
        const barcode = pathname.split('/')[2];

        if (location.search.length > 0) {
            const shopCode = location.search.replace('?shopSeq=', '');
            this.setState({
                barcode,
                shopCode,
                isLoaded: true
            }, () => {
                const isLoaded = setTicketGroupsInStore(barcode, shopCode);
                if(isLoaded) {
                    getTicketInfo(barcode, shopCode).then()
                }
            });
        } else {
            getShopSequence(barcode)
                .then(shopSequence => {
                    this.setState({
                        barcode,
                        shopCode: shopSequence,
                        isLoaded: true
                    }, () => {
                        const isLoaded = setTicketGroupsInStore(barcode, this.state.shopCode);
                        if(isLoaded) {
                            getTicketInfo(barcode, this.state.shopCode).then();
                        }
                    });
                });
        }
    };

    renderGroups(ticketGroups) {
        const barcode = this.props.location.pathname.split('/')[2];
        if (_.isEmpty(ticketGroups)) return;

        return _.map(ticketGroups, (group, index) => {
            const {
                groupName,
                tickets
            } = group;

            return(
                <ReservationTicketItems
                    key={index}
                    groupNm={groupName}
                    tickets={tickets}
                    barcode={barcode}
                />
            )
        })
    }


    render() {

        const location = this.props.location;
        if(!location) return false;

        const barcode = location.pathname.split('/')[2];
        const {
            ticketStore: {
                ticketGroups
            }
        } = this.props;

        const reservationTicketGroups = ticketGroups.toJS().map(ticketGroup => {
            const { groupName, tickets } = ticketGroup;

            return {
                groupName,
                tickets: tickets.toJS().filter(ticket => ticket.reserveOptionUseYn === 'Y')
            }
        });

        return (
            <div className="App">
                <ReservationHeader
                    tab={'reservation'}
                    barcode={barcode}
                />
                <div className="App-container">
                    <div className="group-items">
                        <form>{this.renderGroups(reservationTicketGroups)}</form>
                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/pages/ReservationPage.jsx